import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import PageBanner from "@/components/PageBanner";
import { Languages, Music, Utensils, Users } from "lucide-react";

const features = [
  {
    icon: Languages,
    title: "Rich Cultural Diversity",
    description: "40 languages spoken across 56 ethnic groups in Uganda"
  },
  {
    icon: Music,
    title: "Traditional Performances",
    description: "100+ traditional dances and music performances in Uganda, Kenya, Tanzania, and Rwanda"
  },
  {
    icon: Utensils,
    title: "Local Cuisine",
    description: "50+ local cuisine options, including matooke, chapati, and Rolex in Uganda, and ugali, sukuma wiki, and nyama choma in Kenya and Tanzania"
  },
  {
    icon: Users,
    title: "Community Interaction",
    description: "Authentic cultural experiences through village visits and community interactions"
  }
];

export default function CulturalCulinaryTours() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Cultural & Culinary Tours | Ecoplace Tours</title>
        <meta
          name="description"
          content="Immerse yourself in East Africa's rich cultural heritage with our expert guides through vibrant traditions and flavors."
        />
      </Helmet>

      <PageBanner
        title="Cultural & Culinary Tours"
        description="Immerse yourself in East Africa's rich cultural heritage with our expert guides, who will take you on a journey of discovery through the region's vibrant traditions and flavors."
        backgroundImage="/culture2.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-black-600 max-w-3xl mx-auto font-bold">
            Experience the authentic cultural heritage and culinary delights of East Africa through immersive experiences led by our knowledgeable local guides.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
